import { Component } from '@angular/core';

@Component({
    selector: 'app-ecitation-status',
    templateUrl: './ecitation-status.component.html',
    styleUrls: ['./ecitation-status.component.css'],
    standalone: false
})
export class EcitationStatusComponent {

  selectedTab = 'all';
  showTable = true;

  tableHeaders = [
    { header: 'Citation Number' },
    { header: 'Issued By' },
    { header: 'Transmitted' },
    { header: 'Disposition' },
    { header: 'Destination' },
    { header: 'Attempts' },
    { header: 'Status' },
  ]

  tableData = [
    {
      CitationNumber: 'BG466776',
      IssuedBy:'WI0200400',
      Transmitted:'2023-03-29 10:01:15',
      Disposition:0,
      Destination:'eCitation',
      Attempts:0,
      Status:'queued'
    },
    {
      CitationNumber: 'BG466776',
      IssuedBy:'WI0200400',
      Transmitted:'2023-03-29 10:01:15',
      Disposition:0,
      Destination:'muni',
      Attempts:0,
      Status:'queued'
    },
    {
      CitationNumber: 'BG466776',
      IssuedBy:'WI0200400',
      Transmitted:'2023-03-29 10:01:15',
      Disposition:0,
      Destination:'eCitation',
      Attempts:0,
      Status:'queued'
    },
    {
      CitationNumber: 'BG466776',
      IssuedBy:'WI0200400',
      Transmitted:'2023-03-29 10:01:15',
      Disposition:0,
      Destination:'eCitation',
      Attempts:0,
      Status:'queued'
    },
    {
      CitationNumber: 'BG466776',
      IssuedBy:'WI0200400',
      Transmitted:'2023-03-29 10:01:15',
      Disposition:0,
      Destination:'eCitation',
      Attempts:0,
      Status:'queued'
    },
    {
      CitationNumber: 'BG466776',
      IssuedBy:'WI0200400',
      Transmitted:'2023-03-29 10:01:15',
      Disposition:0,
      Destination:'eCitation',
      Attempts:0,
      Status:'queued'
    }

  ]
}
